module.exports = __webpack_public_path__ + "img/role_6_name.7339f9df.png";